import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, map, pluck, publishReplay, refCount, take } from 'rxjs/operators';
import { ShimanoCountryService } from '../country/shimano-country.service';

export const WAREHOUSE = 'warehouse';
export const FREIGHT = 'freight';
export const VIEWSRP = 'viewsrp';
export const OBSOLETE_PRODUCTS = 'obsolete-products';
export const BIGGER_SKU_IMAGE = 'bigger-sku-image';
export const ACCOUNT_PERMISSIONS = 'account-permissions';
export const SHIP_TO_ADDRESS = 'ship-to-address';
export const FUTURE_ORDER = 'future-order';
export const ADDRESS_NAME = 'address-name';
@Injectable({
  providedIn: 'root',
})
export class SnahCountryService {
  checkEnabled: any;
  warehouseSubscription: Subscription;
  cacheWindowTime = 3600000;

  constructor(protected http: HttpClient, private shimanoCountryService: ShimanoCountryService) {}

  get activeCountry(): string {
    let country: string;
    this.shimanoCountryService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (country = data));
    return country;
  }

  getSNAHFeaturesConfig(): Observable<any> {
    return this.http
      .get(`../../../public/features/SNAH_FEATURES.json`)
      .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandler));
  }

  getSnahFeatures(feature: string): Observable<any> {
    const activeCountry = this.activeCountry;

    if (feature && activeCountry)
      this.checkEnabled = this.getSNAHFeaturesConfig().pipe(
        publishReplay(1, this.cacheWindowTime),
        refCount(),
        take(1),
        pluck('country'),
        map((data: any) => (data[activeCountry] !== undefined ? data[activeCountry] : data['default'])),
        pluck('feature'),
        map((data) => data[feature]['enabled']),
        catchError(this.errorHandler)
      );
    return this.checkEnabled;
  }

  errorHandler(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
